<template>
  <div style="position:relative">
    <table>
      <tr>
        <td class="empty"></td>
        <td class="empty"></td>
        <td class="title-h" colspan="6">来店回数</td>
      </tr>
      <tr>
        <td class="empty"></td>
        <td class="empty"></td>
        <td class="empty"></td>
        <td colspan="2">
          <span>{{ fThresholds[0] }}</span>
        </td>
        <td colspan="2">
          <span>{{ fThresholds[1] }}</span>
        </td>
        <td class="empty"></td>
      </tr>
      <tr>
        <td class="title-v" rowspan="6">週平均金額</td>
        <td class="empty"></td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[0] }}</div>
          <div>
            <md-checkbox :value="rankValues[0]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[1] }}</div>
          <div>
            <md-checkbox :value="rankValues[1]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[4] }}</div>
          <div>
            <md-checkbox :value="rankValues[4]" v-model="checkedRanks" />
          </div>
        </td>
      </tr>
      <tr>
        <td rowspan="2">
          <span>{{ mThresholds[0] }}</span>
        </td>
      </tr>
      <tr>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[2] }}</div>
          <div>
            <md-checkbox :value="rankValues[2]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[3] }}</div>
          <div>
            <md-checkbox :value="rankValues[3]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[5] }}</div>
          <div>
            <md-checkbox :value="rankValues[5]" v-model="checkedRanks" />
          </div>
        </td>
      </tr>
      <tr>
        <td rowspan="2">
          <span>{{ mThresholds[1] }}</span>
        </td>
      </tr>
      <tr>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[6] }}</div>
          <div>
            <md-checkbox :value="rankValues[6]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[7] }}</div>
          <div>
            <md-checkbox :value="rankValues[7]" v-model="checkedRanks" />
          </div>
        </td>
        <td class="cell" colspan="2" rowspan="2">
          <div>{{ rankTexts[8] }}</div>
          <div>
            <md-checkbox :value="rankValues[8]" v-model="checkedRanks" />
          </div>
        </td>
      </tr>
      <tr>
        <td class="empty"></td>
      </tr>
    </table>

    <div
      class="cell"
      style="position: absolute; bottom: 0; right: 0; width: 120px !important; height: 49px;"
    >
      <div>
        {{ rankTexts[9] }}(当期<span>{{ outOfRankText }}</span
        >)
      </div>
      <div>
        <md-checkbox :value="rankValues[9]" v-model="checkedRanks" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 全9区分のランク選択を行うコンポーネント
 */
export default {
  props: {
    mThresholds: {
      type: Array,
      default: () => [6000, 3000],
    },
    fThresholds: {
      type: Array,
      default: () => [12, 6],
    },
    rankValues: {
      type: Array,
      default: () => [
        '11',
        '12',
        '13',
        '21',
        '22',
        '23',
        '31',
        '32',
        '33',
        '90',
      ],
    },
    rankTexts: {
      type: Array,
      default: () => [
        'M1F1',
        'M1F2',
        'M1F3',
        'M2F1',
        'M2F2',
        'M2F3',
        'M3F1',
        'M3F2',
        'M3F3',
        'ランク外',
      ],
    },
    /**
     * チェックされているランク
     */
    ranks: {
      type: Array,
      default: () => [],
    },
    /**
     * ランク外のテキスト
     *
     * 当期間、前期間に応じてランク外の意味合いが違う（流入 or 流出）ので、
     * 表示テキストは利用側からもらいます。
     */
    outOfRankText: {
      type: String,
      default: '',
    },
  },
  computed: {
    checkedRanks: {
      get() {
        return this.ranks
      },
      set(newVal) {
        this.$emit('update:ranks', newVal)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 0;
  table-layout: fixed;
  box-sizing: border-box;
}

td {
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  width: 70px;
}

.cell {
  text-align: center;
  font-size: 12px;
  width: 90px;
  height: 40px;
  border: 1px solid #ddd;
}

.title-h {
  width: 270px;
}

.title-v {
  width: 210px;
}

.empty {
  height: 20px;
}

.threshold-input {
  text-align: right;
}

.h-threshold-input {
  width: 40px;
}

.v-threshold-input {
  width: 60px;
}

.loyal {
  background-color: #ffbcbc;
}

.opportunity {
  background-color: #ddffbc;
}

.other {
  background-color: #bcddff;
}

.md-checkbox {
  margin: 0;
}
</style>
